import api from "@/libs/axios";

/** Where the current browser's FCM token is cached so logout can revoke it. */
export const DEVICE_TOKEN_STORAGE_KEY = "fcm_device_token";

/** POST /api/users/device-token — register/refresh this browser's FCM token. */
export async function registerDeviceToken(token: string): Promise<void> {
  await api.post("/api/users/device-token", { token, platform: "WEB" });
}

/** DELETE /api/users/device-token — stop pushing to a token no longer in use. */
export async function removeDeviceToken(token: string): Promise<void> {
  await api.delete("/api/users/device-token", { data: { token } });
}

/**
 * POST /api/users/logout — revoke device token(s) server-side.
 * Pass this browser's FCM token to remove only it; omit to remove all of
 * the user's device tokens (multi-device logout).
 */
export async function logoutUser(token?: string): Promise<void> {
  await api.post("/api/users/logout", token ? { token } : {});
}
